'use es6';

import { useEffect, useRef } from 'react';
import CharmapInsertPopoverBody from 'rich-text-lib/components/charmap/CharmapInsertPopoverBody';
import TinyMcePopover from './TinyMcePopover';
import useInlineTarget from '../utils/hooks/useInlineTarget';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CharmapPopoverManager(props) {
  const {
    editor,
    onInsert,
    onOpenChange
  } = props;
  const {
    inlineTarget,
    setInlineTarget,
    initInlineTarget,
    insertAtInlineTarget
  } = useInlineTarget(editor, null);
  const lastTarget = useRef(inlineTarget);
  useEffect(() => {
    lastTarget.current = inlineTarget;
  });
  useEffect(() => {
    onOpenChange(!!inlineTarget);
  }, [onOpenChange, inlineTarget]);
  useEffect(() => {
    const handleOpenPopover = () => {
      if (lastTarget.current) {
        setInlineTarget(null, {
          restoreSelection: true
        });
      } else {
        initInlineTarget({
          fireNodeChange: true
        });
      }
    };
    editor.on('OpenCharmapPopover', handleOpenPopover);
    return () => editor.off('OpenCharmapPopover', handleOpenPopover);
  }, [editor, initInlineTarget, setInlineTarget]);
  const handleRemove = () => {
    if (lastTarget.current) {
      setInlineTarget(null);
    }
  };
  const handleInsert = (...args) => {
    insertAtInlineTarget(onInsert.bind(null, ...args));
  };

  // Don't close if opened by the toolbar button
  const shouldCloseOnClick = evt => {
    const isToolbarButton = evt && evt.target && editor.dom.getParent(evt.target, '.mce-toolbar,.mce-hubspot-dropdown');
    return !isToolbarButton;
  };
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    "data-test-id": "charmap-popover-manager",
    editor: editor,
    open: !!inlineTarget,
    target: inlineTarget,
    onRemove: handleRemove,
    shouldCloseOnClick: shouldCloseOnClick,
    onOpenChange: handleRemove,
    arrowSize: "medium",
    placement: "bottom right",
    autoPlacement: "vert",
    animateOnToggle: false,
    renderContent: () => /*#__PURE__*/_jsx(CharmapInsertPopoverBody, {
      onInsert: handleInsert,
      storeHandlers: props.storeHandlers,
      dropdownClassName: props.dropdownClassName
    })
  });
}